import { useMutation, useQuery } from 'react-query';
import { createPaymentOrder, getPaymentOrderStatus } from '../api/paymentApi';

// Hook for creating payment order
export const useCreatePaymentOrder = () => {
  return useMutation({
    mutationFn: createPaymentOrder,
    onError: (error) => {
      console.error('Error creating payment order:', error);
    }
  });
};

// Hook for getting payment order status
export const usePaymentOrderStatus = (orderId) => {
  return useQuery({
    queryKey: ['paymentOrderStatus', orderId],
    queryFn: () => getPaymentOrderStatus(orderId),
    enabled: !!orderId,
    refetchInterval: (data) => {
      // Stop polling if payment is completed or failed
      if (data?.order_status === 'SUCCESS' || data?.order_status === 'FAILED') {
        return false;
      }
      return 2000; // Poll every 2 seconds
    },
    retry: false
  });
}; 